import { callApi } from './ApiClient';

const getOrdersOverview = (data, dispatch) => {
  return callApi('GET', '/orders/overview', data, dispatch);
}

const getOrders = (data, dispatch) => {
  return callApi('GET', '/orders', data, dispatch);
}

const getOrderById = (id, data, dispatch) => {
  return callApi('GET', `/orders/${id}`, data, dispatch);
}

const getOrderAddresses = (id, data, dispatch) => {
  return callApi('GET', `/orders/${id}/addresses`, data, dispatch);
}

export const OrdersApi = {
  getOrdersOverview,
  getOrders,
  getOrderById,
  getOrderAddresses,
};



// WEBPACK FOOTER //
// ./src/redux/api/OrdersApi.js